module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAloAAAAgCAMAAAD9oyZWAAAAIVBMVEVHcEz/7LT/7rf/7bj/7rf/7rj/7rj/7LT/7bT/7bb/7bZM/1nyAAAAC3RSTlMAH6kP4P7JNU5mfMlCVzoAAADbSURBVHja7dlhbsMgDEBhGzCG3P/AqzGdJrVqtmi/2vcdIXpxghEAAAAAAAAAAPCRtAheq6UK/kyb0dZrtVunrStlGW2dlWW0daWs7sytk7KaN9q6UFYV2jopS0VpS6rUoIurp+EjzTG3I+QDo62zsvIlPJaZxhzJhyd1Xeoi72ZXtXIKK6JUUg8tWFAJw+wQPFHMXILbTVv6TUlH+c4tOws7L3nLuh7H1jbnYGr9w9QK4863n1Pr07+e/Gvxr8UJkRMiey32WmAbzzaeO0TuEAEAAAAAAAAAv/YFpwUJbycMeHAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/header-info.png
// module id = g36m
// module chunks = 216